import React, { useState, useEffect } from "react";
import { MainLayout } from "../../../layout/MainLayout";
import ReactPlayer from "react-player";
import { Button } from "../../../components/client/Button/Button";
import Description from "./Description";
import { HOST } from "../../../config";
import ImageModal from "./ImageModal";

export default function Simulation() {
  const [duration, setDuration] = useState(0);
  const [time, setTime] = useState(0);
  const [current, setCurrent] = useState(0);
  const [showImage, setShowImage] = useState(false);
  const [pointNow, setPointNow] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${HOST}/simulation/all/client`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const res = JSON.parse(result);
        setData(res);
        setCurrent(res[0]);
      })
      .catch((error) => console.log("error", error));
  }, []);

  useEffect(() => {
    document.addEventListener(
      "keydown",
      (e) => {
        if (e.code === "Space") {
          e.preventDefault();
          checkPoint();
        }
      },
      true
    );
  });

  function getDuration({ playedSeconds }) {
    setDuration(Math.floor(playedSeconds));
  }

  function checkPoint() {
    if (current) {
      const point = current.point;
      const getPoint = point.split(",").map((v) => {
        const item = v.trim();
        const value = item.split(":");
        return {
          duration: Number(value[0]),
          point: Number(value[1]),
        };
      });
      console.log(getPoint);
      const getDuration = duration;
      for (const item of getPoint) {
        const durationDB = item.duration;
        const point = item.point;
        if (getDuration === durationDB) {
          setPointNow(point);
        }
      }
      setTime(getDuration);
    }
  }

  function handlePick(i) {
    setCurrent(data[i]);
  }

  return (
    <MainLayout>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-2">
        <div className="col-span-2">
          <ReactPlayer
            muted={true}
            controls={true}
            playing={true}
            width="100%"
            height="auto"
            onProgress={getDuration}
            url={current.video}
          />
          <div className="grid border-2 p-2 grid-cols-1 lg:grid-cols-4">
            <p className="col-span-2">
              Tình Huống 1 : Nhấn phím Cách khi phát hiện tình huống
            </p>
            <div className="flex justify-between col-span-2">
              <p className="mr-1">
                Gắn cờ : {time}s Điểm: {pointNow} đ{" "}
              </p>
              <Button
                onClick={() => setShowImage(!showImage)}
                className="bg-[#a0214e]"
              >
                Hiện gợi ý
              </Button>
            </div>
          </div>
          <Button onClick={checkPoint} className="w-full text-white">
            Tính điểm
          </Button>
        </div>
        <div>
          <div className="border-2 p-2">
            {data.map((item, i) => {
              return current.id === item.id ? (
                <Button
                  key={i}
                  onClick={() => handlePick(i)}
                  className="mr-2 mb-2 min-w-[40px] text-white font-bold"
                >
                  {item.name}
                </Button>
              ) : (
                <Button
                  onClick={() => handlePick(i)}
                  key={i}
                  className="mr-2 mb-2 min-w-[40px] bg-[#eeeeee] text-black font-bold"
                >
                  {item.name}
                </Button>
              );
            })}
          </div>
        </div>
      </div>
      <Description />
      {showImage && ImageModal(current.name, current.image, setShowImage)}
    </MainLayout>
  );
}
